var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "h-100" },
        [
          _c(
            "b-row",
            { staticClass: "match-height" },
            _vm._l(_vm.reportTypes, function (reportType, index) {
              return _c(
                "b-col",
                { key: index, staticClass: "h-100", attrs: { md: "6" } },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "cursor-pointer",
                      attrs: { to: reportType.route },
                    },
                    [
                      _c("StatisticCardHorizontal", {
                        staticClass: "square-card",
                        attrs: {
                          iconComponent: reportType.iconComponent,
                          statistic: reportType.title,
                          color: reportType.color,
                          width: "50",
                          colorHex: reportType.colorHex,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }